const AbstractCloverRequestRecord = require('@/lib/PaymentMethods/Clover/Records/Request/AbstractCloverRequestRecord');

class CloverTransactionPaymentRequestRecord extends AbstractCloverRequestRecord {
    /**
     * @link https://docs.clover.com/reference/pay
     *
     * @param {number} amountInMinorUnits
     * @param {string} externalPaymentId
     * @param {string} externalReferenceId
     * @param {} extraDeviceOptions e.g. card not present, do not prompt for cashback etc.
     */
    constructor(amountInMinorUnits, externalPaymentId, externalReferenceId, extraDeviceOptions) {
        const url = '/connect/v1/payments';

        if (!amountInMinorUnits || !Number.isInteger(amountInMinorUnits)) {
            throw new Error('amountInMinorUnits is required and should be an integer');
        }
        if (!externalPaymentId || externalPaymentId.trim() === '') {
            throw new Error('externalPaymentId is required');
        }

        let data = {
            // The api always expects a positive integer.
            amount: amountInMinorUnits,

            // A unique id assigned by the POS to identify this transaction. Critical for reconciliation and recovery.
            // We use payment.thirdPartyId for this. This appears on the Clover Dashboard as 'External ID'.
            externalPaymentId,

            // An ID that can be passed to the merchant's gateway as and ultimately appears in settlement records.
            // Max 12 digits. This appears on the Clover Dashboard as 'Invoice Number'.
            externalReferenceId,

            // If set to true, the payment will run as a closed, non-adjustable transaction (sale), the capture field
            // will be ignored, and the tip will be set to the amount in the tipAmount field, or 0 if the tipAmount is
            // not specified. If set to false then the capture flag is evaluated to determine if the payment will be
            // automatically captured or if a subsequent call to capture is required. In addition, if set to false
            // setting the tipAmount field will result in a validation error.
            final: true,
            deviceOptions: {
                offlineOptions: {
                    // This should not be relevant because we are using Cloud integration, but just in case...
                    allowOfflinePayment: false,
                },
            },
        };

        if (extraDeviceOptions && Object.keys(extraDeviceOptions).length > 0) {
            data.deviceOptions = { ...data.deviceOptions, ...extraDeviceOptions };
        }

        // Note: @see CloverAxiosInstance.js
        // We also use payment.thirdPartyId as the header: Idempotency-Key
        super(
            'POST',
            url
        );
        this.data = data;
    }
}

module.exports = CloverTransactionPaymentRequestRecord;
